import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";
import DocumentListHeader from "layout/discovery/folder/documents/DocumentListHeader";
import { useSelector } from "react-redux";
import { filterThemes, getIsCycle, getMinMaxFreq } from "utils/discovery";
import { hoverSame, unhoverSame } from "utils";
import { getDocListBodyColumns } from "layout/discovery/folder/documents/helpers/renderHelper";
import InfiniteGrid from "components/Grid";
import { sortCategoryList } from "layout/discovery/helpers";

const Documents = ({ docsRef, themeRef }) => {
  const headerRef = useRef();
  const outerListRef = useRef(undefined);
  const innerListRef = useRef(undefined);
  const isCycle = useMemo(getIsCycle, []);

  const allThemes = useSelector((state) => state.discovery.themes);
  const docs = allThemes?.[0]?.Documents;
  const themes = allThemes?.filter((t) => t.GroupName !== "All Themes");
  const isSearch = useSelector((state) => state.discovery.config.isSearch);
  const showAll = useSelector((state) => state.discovery.config.showAll);
  const filterView = useSelector((state) => state.discovery.config.filterView);
  let themeList = filterThemes(themes, showAll, isSearch, filterView);
  themeList = sortCategoryList(themeList, isSearch, filterView);
  const minMax = getMinMaxFreq(themeList, isSearch);

  const renderRow = ({ rowIndex, style }) => (
    <div
      style={style}
      className={`item item-${rowIndex}`}
      onMouseOver={() => hoverSame(rowIndex)}
      onFocus={() => hoverSame(rowIndex)}
      onMouseOut={unhoverSame}
      onBlur={unhoverSame}
    >
      <div className="documents__body__row" data-testid="document-row">
        {getDocListBodyColumns(
          themeList,
          themeList[rowIndex],
          rowIndex,
          docs,
          isSearch,
          filterView,
          showAll,
          minMax
        )}
      </div>
    </div>
  );

  const handleScroll = (scrollLeft, scrollTop) => {
    if (themeRef.current && !isCycle(scrollTop)) {
      themeRef.current.scrollTo({ scrollTop });
    }

    const header = headerRef.current;
    if (header && outerListRef.current) {
      // If body has scrollbar add it to header too.
      if (scrollLeft && header.style.overflowY !== "scroll") {
        header.style.overflowY = "scroll";
      } else if (!scrollLeft && header.style.overflowY !== "hidden") {
        header.style.overflowY = "hidden";
      }

      header.scrollLeft = scrollLeft;
    }
  };

  return (
    <div className="documents" data-testid="documents-pane">
      <DocumentListHeader headerRef={headerRef} />
      <div className="documents__body" data-testid="documents-body">
        <InfiniteGrid
          listRef={docsRef}
          rowSize={26}
          outerRef={outerListRef}
          innerRef={innerListRef}
          rowCount={themeList.length}
          onScroll={(scrollLeft, scrollTop) =>
            handleScroll(scrollLeft, scrollTop)
          }
          renderRow={renderRow}
          columnCount={1}
        />
      </div>
    </div>
  );
};

export default Documents;

Documents.propTypes = {
  docsRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  themeRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};
